import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
// import { jsPDF } from 'jspdf'; // Removed - PDF functionality not used


import PrimaryMathsContainer from './components/PrimaryMathsContainer';
import FloatingChatWindow from './components/FloatingChatWindow';
import ChatWithAIButton from './components/ChatWithAIButton';
import A2AServerToggle from './components/A2AServerToggle';

import TextSizeControl from './components/TextSizeControl';
import TranslationTrigger from './components/TranslationTrigger';
import TranslationHelper from './components/TranslationHelper';
import { TextSizeProvider } from './contexts/TextSizeContext';
import { LanguageProvider } from './contexts/LanguageContext';

// import './utils/mathJaxOverride'; // Disabled to prevent blank content

const App = () => {
  // Removed activeTab state - only showing primary mathematics now

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatContext, setChatContext] = useState({});







  // Chat functions
  const handleOpenChat = (context) => {
    setChatContext(context);
    setIsChatOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
    setChatContext({});
  };

  const handleSaveAsQuizlet = (quizletData) => {
    // Quizlet save functionality removed
    console.log('Quizlet save functionality removed:', quizletData);
  };

  const handleSaveAsDrill = (drillData) => {
    // Drill save functionality removed
    console.log('Drill save functionality removed:', drillData);
  };

  const handleReturnToTopic = () => {
    console.log('Returning to topic:', chatContext);
  };

  // Enhanced PDF generation using jsPDF (placeholder) - functionality removed
  // const generatePDF = () => {
  //   const doc = new jsPDF();
  //   // PDF generation functionality removed
  // };

  // const resetTemplate = () => {
  //   // Reset template placeholder - functionality removed
  // };

  return (
    <LanguageProvider>
      <TextSizeProvider>
        <div className="min-h-screen bg-gray-50">
        {/* Header with Unsplash Background */}
        <div 
          className="relative bg-blue-600 text-white p-8"
          style={{
            backgroundImage: 'linear-gradient(rgba(37, 99, 235, 0.8), rgba(37, 99, 235, 0.8)), url(https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1973&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="relative z-10 max-w-7xl mx-auto">
            <div className="flex justify-between items-start">
              <div>
                <h1 className="text-4xl font-bold mb-3">數學日常 PriMathsDaily</h1>
                <p className="text-blue-100 text-lg">使用AI驅動的數學學習系統，專注小學數學基礎教育</p>
              </div>
              <div className="hidden md:block">
                <TextSizeControl />
              </div>
            </div>
          </div>
        </div>

      {/* Simplified Navigation - Only Primary Mathematics */}
      <div className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-2">
              <GraduationCap className="w-5 h-5 text-blue-600" />
              <h2 className="text-lg font-semibold text-gray-800">小學數學</h2>
            </div>
            <div className="md:hidden">
              <TextSizeControl />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Primary Mathematics Content */}
        <PrimaryMathsContainer />
      </div>

      {/* Global Floating Chat Button */}
      <ChatWithAIButton
        onClick={handleOpenChat}
        context={{ title: 'PriMathsDaily 數學助手', id: 'math-general' }}
        position="floating"
        variant="floating"
        size="large"
      />

      {/* Floating Chat Window */}
      <FloatingChatWindow
        isOpen={isChatOpen}
        onClose={handleCloseChat}
        context={chatContext}
        onSaveAsQuizlet={handleSaveAsQuizlet}
        onSaveAsDrill={handleSaveAsDrill}
        onReturnToTopic={handleReturnToTopic}
      />
      
      {/* Translation Trigger Component */}
      <TranslationTrigger />
      
      {/* Translation Helper Component */}
      <TranslationHelper />
      
      {/* A2A Server Toggle */}
      <A2AServerToggle />
    </div>
      </TextSizeProvider>
    </LanguageProvider>
  );
};

export default App;
